var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend legend-stall-risk-point"},_vm._l((_vm.dispData),function(e){
var _obj;
return _c('div',{key:e.val,staticClass:"cell",class:( _obj = {}, _obj['val-'+e.val] = true, _obj )},[_c('i',{staticClass:"fas fa-star ib vm",style:({
      'color': e.strokeColor,
    })}),_c('span',{staticClass:"ib vm label"},[_vm._v(_vm._s(e.label))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }